export default __webpack_public_path__ + "static/damixa-lead-bg@1x-f3a4ec1367814902450b3fed4af32045.jpg";